import { Props } from './types';
import * as Styled from './styled';
import Spinner from '~components/svgs/Spinner';

function Button({
  onClick,
  children,
  disabled,
  variant,
  width,
  height,
  loading,
  icon,
  ...rest
}: Props) {
  return (
    <Styled.Button
      onClick={onClick}
      disabled={disabled}
      $variant={variant}
      $width={width}
      $height={height}
      {...rest}
    >
      {loading ? <Spinner /> : children}
      {!loading && icon && <Styled.ContainerIcon>{icon}</Styled.ContainerIcon>}
    </Styled.Button>
  );
}

Button.defaultProps = {
  color: 'primary',
  disabled: false,
  height: 48,
  type: 'button',
};

export default Button;
